import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-search',
  templateUrl: './button-search.component.html',
  styleUrls: ['./button-search.component.scss']
})
export class ButtonSearchComponent implements OnInit {

  semestre: string = "S8";

  str = `
  "Formats de données du Web ; M1 WIC ; S8 ; Manuel ATENCIA ARCAS ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5233 ; CM ; 22/03/2021 ; 08h30 ; 10h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93856883216?pwd=ZVlSSEFtelZzQ0xVbVNHNm1TUmVKZz09 "
  "Formats de données du Web ; M1 WIC ; S8 ; Manuel ATENCIA ARCAS ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5233 ; TD ; 22/03/2021 ; 10h15 ; 11h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93856883216?pwd=ZVlSSEFtelZzQ0xVbVNHNm1TUmVKZz09 "
  "Interface Homme Machine ; M1 WIC ; S8 ; Julie DUGDALE ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5245 ; CM ; 23/03/2021 ; 10h00 ; 12h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/95163181509?pwd=a29aNWs1MlFhZnVSeHBGRVYwQk5IUT09 "
  "Interface Homme Machine ; M1 WIC ; S8 ; Julie DUGDALE ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5245 ; TD ; 24/03/2021 ; 15h00 ; 16h30 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93856929530?pwd=L2t3VUZ5UWZxN29GUmZIWG9KNVpZdz09 "
  "Programmation web côté client ; M1 WIC ; S8 ; CHEVALLIER ; https://miashs-www.u-ga.fr/~chevallj/;TP;23/03/2021 ; CM ; 24/03/2021 ; 14h00 ; 16h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/my/chevallj "
  "Informatique décisionnelle ; M1 WIC ; S8 ; Sophie DUPUY-CHESSA ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5234 ; CM ; 24/03/2021 ; 08h30 ; 10h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/my/dupuychessa "
  "Informatique décisionnelle ; M1 WIC ; S8 ; Sophie DUPUY-CHESSA ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5234 ; TD ; 24/03/2021 ; 10h15 ; 11h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/my/dupuychessa "
  "Etudes comportementales ; M1 WIC ; S8 ; Raphaêl LABOISSIERE ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=9468 ; TD ; 25/03/2021 ; 08h30 ; 10h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/98475171423?pwd=eFpvV2loYWZOc2FKdkJjVWE2aDFpUT09 "
  "Anglais ; M1 WIC ; S8 ; Sally BROWN ; https://drive.google.com/drive/folders/1MnnR_lGtEn7P8y5Hk5Cle6Zcf0gSWUp5 ; CM ; 25/03/2021 ; 13h00 ; 16h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/94725267235?pwd=ajF6dWkzUmpFd2Fob2hlVU9HWTFtQT09 "
  "Gestion de projet ; M1 WIC ; S8 ; Lucas BISOGNIN ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244 ; CM ; 26/03/2021 ; 13h30 ; 15h30 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 "
  "Gestion de projet ; M1 WIC ; S8 ; Lucas BISOGNIN ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244 ; CM ; 26/03/2021  ; 15h45 ; 17h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 "
  "Gestion de projet ; M1 WIC ; S7 ; Lucas BISOGNIN ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244 ; CM ; 26/03/2021  ; 15h45 ; 17h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 "
  "Gestion de projet ; M1 WIC ; S7 ; Lucas BISOGNIN ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244 ; CM ; 26/03/2021  ; 15h45 ; 17h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 "
  "Gestion de projet ; M1 WIC ; S9 ; Lucas BISOGNIN ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244 ; CM ; 26/03/2021  ; 15h45 ; 17h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 "
  "Gestion de projet ; M1 WIC ; S9 ; Lucas BISOGNIN ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244 ; CM ; 26/03/2021  ; 15h45 ; 17h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 "
  `;

  tab: any = this.parse(this.str);
  id: number = 0;
  name: string = "buttonsearch";
  
  constructor() { }

  ngOnInit(): void {
  }

  parse(str: string): COURS[] {

    const L: COURS [] = str.trim().split("\n").map(s => s.trim()).filter(s => s!=="")

                 .map( s => s.split(";").map( s => s.slice(1, -1) ) )

                 .map( ([n,f, s,pr,w,t]) => ({

                   nom: n,
                   
                   filiaire: f,

                   semestre: s,

                   prof: pr,
                   
                   web: w,
                   
                   type: t,

                   
                     
                  

                 }));

    return L;

  }

  setId(event :any) {
    console.log(event);
    console.log(event.target.id);
    this.id = event.target.id;
  }

  sendInfo(id:number) {
    return [this.tab[id].nom, this.tab[id].filiaire,this.tab[id].semestre, this.tab[id].prof, this.tab[id].web, this.tab[id].type];
  }

  rechercheCours() {
    let input, filter, ul, li, a, i, txtValue;
    input = (<HTMLInputElement>document.getElementById("inputCours"));
    filter = input.value.toUpperCase();
   ul = document.getElementById("ulCours");
   if(ul!=null){
    li = ul.getElementsByTagName("li");
    for (i = 0; i < li.length; i++) {
      a = li[i].getElementsByTagName("a")[0];
      txtValue = a.textContent || a.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        li[i].style.display = "";
      } else {
        li[i].style.display = "none";
      }
    }
  }
  }
  
  DateCours(ind: number) {
    let filter, ul, li, a, i, txtValue;
    if (ind == 1) {
      filter = "S7";
    }
    else if (ind == 2) {
      filter =  this.semestre
    }
    else {
      filter = "S9"
    }
   ul = document.getElementById("ulCours");
   if(ul!=null){
    li = ul.getElementsByTagName("li");
     for (i = 0; i < li.length; i++) {
       a = li[i].getElementsByTagName("a")[0];
       txtValue = a.getAttribute('name');
       if (txtValue != null) {
         if (txtValue == filter) {
           li[i].style.display = "";
         } else {
           li[i].style.display = "none";
         }
       }
     }
  }
}


}

interface COURS {

  nom: string;

  filiaire: string;
  
  semestre: string;

  prof: string;

  web: string;

  type: string;

}
